<template>
  <div>
    <!-- <Form v-slot="{errors}" @submit="playerApply(form)">
      <div class="cartTotalTab row g-3">
        <h2><span>報名方式</span></h2>
        <p class="txt">報名時間：9月8日 - 9月22日</p>
        <div class="col-md-6">
          <label for="name" class="form-label">姓名</label>
          <Field id="name" name="姓名" type="text" class="form-control" :class="{ 'is-invalid': errors['姓名'] }" placeholder="請填寫真實姓名" rules="required" v-model="form.username"></Field>
          <error-message name="姓名" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="tel" class="form-label">手機電話</label>
          <Field id="tel" name="電話" type="tel" class="form-control" :class="{'is-invalid': errors['電話']}" placeholder="請輸入電話" rules="required" v-model="form.phone"></Field>
          <error-message name="電話" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="email" class="form-label">電子信箱</label>
          <Field id="email" name="email" type="email" class="form-control" :class="{ 'is-invalid': errors['email'] }" placeholder="請輸入 Email" rules="email|required" v-model="form.email"></Field>
          <error-message name="email" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="idnumber" class="form-label">身分證字號</label>
          <Field id="idnumber" name="身分證字號" type="text" class="form-control" :class="{ 'is-invalid': errors['身分證字號'] }" placeholder="請輸入身分證字號" rules="required" v-model="form.idcard"></Field>
          <error-message name="身分證字號" class="invalid-feedback"></error-message>
          <span class="note">比賽當日核對身分使用，請務必填寫正確+攜帶有照片之證件</span>
        </div>
        <div class="col-md-6">
          <label for="birth" class="form-label">出生年月日</label>
          <Field id="birth" name="出生年月日" type="date" class="form-control" :class="{ 'is-invalid': errors['出生年月日'] }" placeholder="請輸入出生年月日" rules="required" v-model="form.birthdate"></Field>
          <error-message name="出生年月日" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="height" class="form-label">身高</label>
          <Field id="height" name="身高" type="number" class="form-control" :class="{ 'is-invalid': errors['身高'] }" placeholder="請輸入身高" rules="required" v-model="form.height"></Field>
          <error-message name="身高" class="invalid-feedback"></error-message>
          <span class="note">比賽訓練台設定使用，請務必填寫正確</span>
        </div>
        <div class="col-md-6">
          <label for="weight" class="form-label">體重</label>
          <Field id="weight" name="體重" type="number" class="form-control" :class="{ 'is-invalid': errors['體重'] }" placeholder="請輸入體重" rules="required" v-model="form.weight"></Field>
          <error-message name="體重" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="FTP" class="form-label">FTP</label>
          <Field id="FTP" name="FTP" type="number" class="form-control" :class="{ 'is-invalid': errors['FTP'] }" placeholder="請輸入FTP" rules="required" v-model="form.ftp"></Field>
          <error-message name="FTP" class="invalid-feedback"></error-message>
          <span class="note">請提供最近兩週至一個月內的數據資訊</span>
        </div>
        <div class="cartBtnBox">
          
          <div class="btnCarAgree"><button type="submit" @click="validate" class="btn btn--primary">我要報名</button></div>
          <div class="clearer"></div>
        </div>
      </div>
    </Form> -->

    <!-- 為了把 data 的 form 寫到 vuex -->
    <!-- <Form v-slot="{errors}" @submit="playerApply(form)"> -->
    <Form v-slot="{errors}" @submit="playerConsent('Consent')">
      <div class="cartTotalTab row g-3 themeBox">
        <h2><span>報名方式</span></h2>
        <p class="txt">
          請詳細閱讀賽事規章，並且了解免責聲明之內容<br>TT曜越單車電競爭霸戰，隨時等待你的挑戰！
        </p>
        <div class="word">
          <div class="info bike">
            <ul>
              <li><strong>報名時間：</strong>即日起至2022年10月12日(星期三) 12:00。</li>
              <li><strong>報名時間：</strong>採線上報名，報名截止後將於10/12(星期三) 16:00公告選手資訊。</li>
              <li>若因不可歸責於主辦單位之事由（如：疫情、天災等），致活動無法舉行，主辦單位將有權將活動改期，主辦單位將自動保留所有完成報名的參賽資格。</li>
              <li>請參賽者知悉並同意比賽配備要求與免責同意書等條款後，再進行報名。</li>
            </ul>
          </div>
        </div>
        <div class="col-md-6">
          <label for="name" class="form-label">姓名</label>
          <Field id="name" name="姓名" type="text" class="form-control" :class="{ 'is-invalid': errors['姓名'] }" placeholder="請填寫真實姓名" rules="required" v-model="username"></Field>
          <error-message name="姓名" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="tel" class="form-label">手機電話</label>
          <Field id="tel" name="電話" type="tel" class="form-control" :class="{'is-invalid': errors['電話']}" placeholder="請輸入電話" rules="required" v-model="phone"></Field>
          <error-message name="電話" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="email" class="form-label">電子信箱</label>
          <Field id="email" name="email" type="email" class="form-control" :class="{ 'is-invalid': errors['email'] }" placeholder="請輸入 Email" rules="email|required" v-model="email"></Field>
          <error-message name="email" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="idnumber" class="form-label">身分證字號</label>
          <Field id="idnumber" name="身分證字號" type="text" class="form-control" :class="{ 'is-invalid': errors['身分證字號'] }" placeholder="請輸入身分證字號" rules="required" v-model="idcard"></Field>
          <error-message name="身分證字號" class="invalid-feedback"></error-message>
          <span class="note">比賽當日核對身分使用，請務必填寫正確+攜帶有照片之證件</span>
        </div>
        <div class="col-md-6">
          <label for="birth" class="form-label">出生年月日</label>
          <Field id="birth" name="出生年月日" type="date" class="form-control" :class="{ 'is-invalid': errors['出生年月日'] }" placeholder="請輸入出生年月日" rules="required" v-model="birthdate"></Field>
          <error-message name="出生年月日" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="height" class="form-label">身高</label>
          <Field id="height" name="身高" type="number" class="form-control" :class="{ 'is-invalid': errors['身高'] }" placeholder="請輸入身高" rules="required" v-model="height"></Field>
          <error-message name="身高" class="invalid-feedback"></error-message>
          <span class="note">比賽訓練台設定使用，請務必填寫正確</span>
        </div>
        <div class="col-md-6">
          <label for="weight" class="form-label">體重</label>
          <Field id="weight" name="體重" type="number" class="form-control" :class="{ 'is-invalid': errors['體重'] }" placeholder="請輸入體重" rules="required" v-model="weight"></Field>
          <error-message name="體重" class="invalid-feedback"></error-message>
        </div>
        <div class="col-md-6">
          <label for="FTP" class="form-label">FTP</label>
          <Field id="FTP" name="FTP" type="number" class="form-control" :class="{ 'is-invalid': errors['FTP'] }" placeholder="請輸入FTP" rules="required" v-model="ftp"></Field>
          <error-message name="FTP" class="invalid-feedback"></error-message>
          <span class="note">請提供最近兩週至一個月內的數據資訊</span>
        </div>
        <div class="cartBtnBox">
          <div class="btnCarAgree"><button type="submit" @click="validate" class="btn btn--primary">我要報名</button></div>
          <div class="clearer"></div>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapState({
      form: 'form', // 為了把 data 的 form 寫到 vuex(先從 vuex 取得 state 資料讓下面 get)
      // form: state => state.form,
    }),
    // 為了把 data 的 form 寫到 vuex(再把上面的 input 所有 v-model 寫成下面 get set)
    username: {
      get() {
        return this.form.username
      },
      set(val) {
        this.$store.commit('setForm', {
          ...this.form,
          username: val
        });
      }
    },
    phone: {
      get() {
        return this.form.phone
      },
      set(val) {
        this.$store.commit('setForm', {
          ...this.form,
          phone: val
        });
      }
    },
    email: {
      get() {
        return this.form.email
      },
      set(val) {
        this.$store.commit('setForm', {
          ...this.form,
          email: val
        });
      }
    },
    address: {
      get() {
        return this.form.address
      },
      set(val) {
        this.$store.commit('setForm', {
          ...this.form,
          address: val
        });
      }
    },
    idcard: {
      get() {
        return this.form.idcard
      },
      set(val) {
        this.$store.commit('setForm', {
          ...this.form,
          idcard: val
        });
      }
    },
    birthdate: {
      get() {
        return this.form.birthdate
      },
      set(val) {
        this.$store.commit('setForm', {
          ...this.form,
          birthdate: val
        });
      }
    },
    weight: {
      get() {
        return this.form.weight
      },
      set(val) {
        this.$store.commit('setForm', {
          ...this.form,
          weight: val
        });
      }
    },
    height: {
      get() {
        return this.form.height
      },
      set(val) {
        this.$store.commit('setForm', {
          ...this.form,
          height: val
        });
      }
    },
    ftp: {
      get() {
        return this.form.ftp
      },
      set(val) {
        this.$store.commit('setForm', {
          ...this.form,
          ftp: val
        });
      }
    },

  },
  methods: {
    playerConsent(name) {
      this.$emit('emit-component', name)
      // this.$emit('emit-form', this.form)
    },
    
  },
}
</script>

<style scoped>
.themeBox .info ul li {
  font-size: var(--text-base-size, 1rem);
}
.themeBox .info ul {
  list-style: none;
  padding: 0;
}
.themeBox .info ul li {
  padding-left: 20px !important;
  background-image: url(@/assets/images/icon_2.png);
  background-position: 0 50%;
  background-repeat: no-repeat;
}
</style>